export default __webpack_public_path__ + "static/1-45326a4ad61bfb7fcc3c29ed2b1ac319.jpeg";